jQuery(document).ready(function($) {

    $( ".bloc_valeurs_entites" ).each(function( index ) {

        var $bloc = $(this)
        var $container = $bloc.find(".sliderContainer")
        var $slider = $bloc.find(".cardsSlider")

        // Défilement horizontal épinglé réservé au desktop. Sous 1024px les
        // cartes défilent nativement au doigt (voir valeurs_entites.scss) ;
        // matchMedia annule le pin et le décalage en changeant de palier.
        var mm = gsap.matchMedia()

        mm.add("(min-width: 1024px)", function() {

            gsap.to( $container , {
                // Recalculé à chaque refresh (redimensionnement de la fenêtre)
                x : function() {
                    return -( $slider.outerWidth() - $(window).width() )
                },
                duration: 3,
                scrollTrigger: {
                    trigger: $container,
                    start: "top 0%",
                    markers: false,
                    pin: true,
                    end: "+=3000",
                    scrub : 1,
                    invalidateOnRefresh: true
                }

            })

        })

    })

});
